import React from 'react';
import { useAuth } from './auth/AuthContext';
import LoginPage from './components/LoginPage';
import DashboardPage from './components/DashboardPage';
import Loading from './components/common/Loading';
import './App.css';

function App() {
  const { token, loading } = useAuth();

  if (loading) {
    return <Loading />;
  }

  if (!token) {
    return <LoginPage />;
  }

  return <DashboardPage />;
}

export default App;